import {
	MapModes,
	ReactMap,
	ReactMapProps,
	SourceType,
} from '@innovyze/inno-map';
import { InfoCard } from '@innovyze/stylovyze';
import { useGlobalization } from '@Translations';
import { LiftStationFormFields } from '@Types';
import { parseLocationToArray } from '@Utils/parseLocation';
import { useFormikContext } from 'formik';
import React, { useMemo } from 'react';
import useNavigateTo from '../../hooks/useNavigateTo';
import { MapContainer, MapWrapper } from './UpsertLiftStationsForm.styles';
import { useReactMapConfig } from '@innovyze/stylovyze';

const layerConfig: ReactMapProps['layerConfig'] = [
	{
		layerName: 'Station',
		dataServiceId: 'assets',
		type: 'symbol',
		icon: 'station',
	},
];

export default function UpsertLiftStationMap() {
	useNavigateTo();
	const { t } = useGlobalization();
	const { values } = useFormikContext<LiftStationFormFields>();
	const { location } = values;

	const dataServices = useMemo(() => {
		return [
			{
				type: SourceType.ONU,
				id: 'assets',
				displayName: 'assets',
				data: {
					type: 'FeatureCollection',
					features: [
						{
							type: 'Feature',
							properties: {
								_id: 'customer#987789',
							},
							geometry: {
								type: 'Point',
								coordinates: parseLocationToArray(location) ?? [
									0, 0,
								],
							},
						},
					],
				},
			},
		];
	}, [location]);

	const reactMapConfig = useReactMapConfig();

	return (
		<InfoCard fullHeight title={t('Location')} applyBodyPadding={false}>
			<MapContainer>
				<MapWrapper>
					<ReactMap
						config={reactMapConfig}
						dataServices={dataServices}
						layerConfig={layerConfig}
						mode={MapModes.Static}
					/>
				</MapWrapper>
			</MapContainer>
		</InfoCard>
	);
}
